import type { TLoansRestoredData } from 'shared/types/TCustomerService';

import type { TCreditFormEntityReducer } from '../../types';

import { mapBaseDataToCreditForm } from './mapBaseDataToCreditForm';

export const mapLoansRestoreDataToCreditForm = (
  state: TCreditFormEntityReducer,
  data: Partial<TLoansRestoredData['customer']>,
) => {
  return mapBaseDataToCreditForm(state, data, {
    periodSourceValue: data.term,
    userAgreement: true,
    advertisingAgreement: true,
    registrationAddressFlat: '',
    residenceAddressFlat: '',
    residenceAddressIsRegistration: data.registrationAddress?.dadata === data.residenceAddress?.dadata,
    // TODO обновить swagger customer service, чтобы там был okved
    okved: (data as unknown as Record<string, string | undefined>).okved || '',
  });
};
